import React, { useEffect, useState } from 'react';

interface PhoneNumberModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (phone: string) => void;
}

export const PhoneNumberModal: React.FC<PhoneNumberModalProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (!open) setValue('');
  }, [open]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim().length < 8) return;
    onSubmit(value.trim());
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
        <h2 className="text-lg font-semibold mb-3 text-primary">
          Phone Number Required
        </h2>
        <p className="mb-4 text-sm text-gray-600">
          To add this product to your favorites, we need your phone number.
          We’ll only ask once and it helps us link your favorites to your
          account.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="tel"
            placeholder="Enter phone number"
            value={value}
            onChange={e => setValue(e.target.value)}
            className="border rounded px-3 py-2 w-full mb-3"
            required
            autoFocus
          />
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              onClick={() => {
                onClose();
                setValue('');
              }}
              className="px-3 py-2 rounded-full bg-gray-200 text-gray-800"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-3 py-2 rounded-full bg-primary text-white"
            >
              Save & Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
